/**
 * Artist-facing copy (claim page, and onboarding/sign-in for an artist arriving from a claim link).
 * No earnings, rewards or speculation language here: artists are not players.
 */
// The headline must be true: "already listening" only when fans have actually added or
// nominated the artist (playlist_count > 0 or nominator_count > 0).
export const ARTIST_HEADLINE_ACTIVE = 'Fans are already listening to your live shows.';
export const ARTIST_HEADLINE = 'Your live shows are on SoundDAO.';
export const artistHeadline = ({ playlistCount = 0, nominatorCount = 0 } = {}) =>
  (playlistCount > 0 || nominatorCount > 0 ? ARTIST_HEADLINE_ACTIVE : ARTIST_HEADLINE);
export const ARTIST_PITCH =
  'Claim your page to see who\'s playing your music, share your recordings, and connect with the fans who found you.';
export const ARTIST_FIRST_CLAIM = 'Be the first artist from the Archive to claim your page.';

